<template>
  <div class="page-content-title no-print">
    <div class="left">
      <!-- {{ data.toReset }} -->
      <!-- @if(data.backBtn) -->
      <span v-if="data.backBtn">
        <!-- {{ data.toReset ? "Yes" : "No" }} -->
        <button
          v-if="data.toReset"
          class="btn-back"
          @click="() => data.toReset()"
          :id="idBackButton"
        >
          <i class="material-symbols-outlined">arrow_back</i>
        </button>
        <button v-else class="btn-back" @click="goBack" :id="idBackButton">
          <i class="material-symbols-outlined">arrow_back</i>
        </button>
      </span>
      <!-- @endif -->
      <div>
        <h4 :class="'title ' + (data.subtitle ? '' : 'mb-0')">
          {{ data.title }}
        </h4>
        <!-- @if(data.breadcrumb.length) -->
        <ol v-if="data.breadcrumb && data.breadcrumb.length" class="breadcrumb">
          <li
            v-for="item in data.breadcrumb"
            :class="'breadcrumb-item ' + (item.active ? 'active' : '')"
            v-bind:key="item.title"
          >
            <span v-if="item.active">
              {{ item.title }}
            </span>
            <button
              class="p-0 text-primary"
              v-else-if="data.toReset"
              @click="() => data.toReset(item.link, false, true)"
            >
              {{ item.title }}
            </button>
            <router-link v-else :to="item.link">{{ item.title }}</router-link>
          </li>
        </ol>

        <!-- @endif -->
        <!-- @if(data.subtitle) -->
        <h5 v-if="data.subtitle" class="subtitle">{{ data.subtitle }}</h5>
        <!-- @endif -->
      </div>
    </div>

    <div v-if="data.actionBtn && data.actionBtn.length" class="action">
      <!-- @each(item in data.actionBtn) -->
      <span v-for="item in data.actionBtn" v-bind:key="item.label">
        <!-- @if(item.type=='status') -->
        <span
          v-if="item.type == 'status'"
          :class="'badge ' + item.className + ' ml-2'"
        >
          <!-- @if(item.iconLeft) -->
          <i v-if="item.iconLeft" class="material-symbols-outlined">{{
            item.iconLeft
          }}</i>
          <!-- @endif -->
          {{ item.label }}
          <!-- @if(item.iconRight) -->
          <i v-if="item.iconRight" class="material-symbols-outlined">{{
            item.iconRight
          }}</i>
          <!-- @endif -->
        </span>
        <!-- @else -->
        <span v-else>
          <button
            v-if="item.type == 'modal'"
            :data-target="item.link"
            data-toggle="modal"
            :class="'btn ' + (item.class ? item.class : '') + ' ml-2'"
            id="item.id"
          >
            <!-- @if(item.iconLeft) -->
            <i v-if="item.iconLeft" class="material-symbols-outlined">{{
              item.iconLeft
            }}</i>
            <!-- @endif -->
            {{ item.label }}
            <!-- @if(item.iconRight) -->
            <i v-if="item.iconRight" class="material-symbols-outlined">{{
              item.iconRight
            }}</i>
            <!-- @endif -->
          </button>
          <button
            v-else-if="item.type == 'function'"
            @click="item.function"
            :class="'btn ' + (item.class ? item.class : '') + ' ml-2'"
            id="item.id"
          >
            <!-- @if(item.iconLeft) -->
            <i v-if="item.iconLeft" class="material-symbols-outlined">{{
              item.iconLeft
            }}</i>
            <!-- @endif -->
            {{ item.label }}
            <!-- @if(item.iconRight) -->
            <i v-if="item.iconRight" class="material-symbols-outlined">{{
              item.iconRight
            }}</i>
            <!-- @endif -->
          </button>
          <router-link
            v-else
            :to="item.link"
            :class="'btn ' + (item.class ? item.class : '') + ' ml-2'"
            id="item.id"
            :target="item.target || '_self'"
          >
            <!-- @if(item.iconLeft) -->
            <i v-if="item.iconLeft" class="material-symbols-outlined">{{
              item.iconLeft
            }}</i>
            <!-- @endif -->
            {{ item.label }}
            <!-- @if(item.iconRight) -->
            <i v-if="item.iconRight" class="material-symbols-outlined">{{
              item.iconRight
            }}</i>
            <!-- @endif -->
          </router-link>
        </span>
        <!-- @endif -->
      </span>
      <!-- @endeach -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PageContentHeader",
  props: {
    data: Object,
    fromTab: String,
    fromUrl: String,
  },
  data: () => {
    return {
      idBackButton: `btnBack${Math.random()}`,
    };
  },
  methods: {
    goBack() {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (this.data && this.data.backBtn)
          this.$router.push({
            path:
              this.data.backBtn + (this.fromTab ? "?tab=" + this.fromTab : ""),
          });
        else this.$router.go(-1);
      } else if (this.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.fromTab;
        //console.log(queryString);
        if (urlArray[1]) {
          //console.log(urlArray[1]);
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
              //console.log(queryString);
            }
            //console.log(queryString);
          }
          //console.log(urlArray[1]);
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    // handlePopstate(event) {
    //   var that = this;
    //   console.log("going in");
    //   that.data.toReset ? that.data.toReset() : that.goBack();
    //   // this.reset(`/ralan/detail/${this.$route.params.id}`, false, true);
    // },
  },
  mounted() {
    // this.idBackButton = `btnBack${Math.random()}`;
    // var that = this;
    // // window.onpopstate = function(event) {
    // //   // if (!that.clicked) {
    // //   //   that.clicked = !that.clicked;
    // //   //   that.data.toReset ? that.data.toReset() : that.goBack();
    // //   // }
    // //   // that.data.toReset ? that.data.toReset() : that.goBack();
    // //   // var btn = document.getElementById(that.idBackButton);
    // //   // btn.addEventListener("click", function() {
    // //   //   console.log("button clicked");
    // //   // });
    // //   // console.log(btn);
    // //   // btn.click();
    // // };
  },
  // created() {
  //   window.addEventListener("popstate", (event) => this.handlePopstate(event));
  // },
  // beforeDestroy() {
  //   window.removeEventListener("popstate", (event) =>
  //     this.handlePopstate(event)
  //   );
  // },
};
</script>
